import { useTranslation } from 'react-i18next';

import { Button } from '@app/shared/ui/atoms/Common';
import { generateReferralLink, getTelegramWebApp } from '@app/shared/utils/common';
import {
  useGetCurrentUserProfileQuery,
  useGetCurrentUserQuery,
} from '@app/store/slices/users/usersApi';
import { sharePractices, shareRef } from '@app/assets';

export type ShareType = 'practices' | 'refs';

interface ShareButtonProps {
  cookie?: { text: string | null; image: string | null };
  className?: string;
  type?: ShareType;
}

export const ShareButton = ({ cookie, className, type = 'refs' }: ShareButtonProps) => {
  const { t } = useTranslation();
  const { data: user } = useGetCurrentUserQuery();
  const { data: profile } = useGetCurrentUserProfileQuery();

  const handleShare = () => {
    const tg = getTelegramWebApp();
    if (!tg) {
      return;
    }
    const referralLink = user ? generateReferralLink(user.id) : null;
    if (!referralLink) {
      return;
    }

    if (tg.isVersionAtLeast('7.8') && (tg.platform === 'android' || tg.platform === 'ios')) {
      if (cookie?.text && cookie.image) {
        tg.shareToStory(cookie.image, {
          text: cookie.text,
          widget_link: {
            url: referralLink,
            name: 'Open DOM',
          },
        });
      } else {
        const imageToSend = type === 'practices' ? sharePractices : shareRef;
        const text =
          type === 'refs'
            ? t(`share.refs.${profile?.gender === 'f' ? 'female' : 'male'}`)
            : t('share.practices');

        tg.shareToStory(imageToSend, {
          text: text + referralLink,
          widget_link: {
            url: referralLink,
            name: 'Open DOM',
          },
        });
      }
    } else {
      tg.openTelegramLink(`https://t.me/share/url?url=${encodeURIComponent(referralLink)}`);
    }
  };

  return (
    <Button onClick={handleShare} className={className}>
      {t('common.share')}
    </Button>
  );
};
